import { useCallback, useMemo } from 'react';
import { SortingState } from '@tanstack/react-table';

import { useStatic } from '~/common/hooks/useStatic';
import { Sorting } from '../../../../types';
import {
  convertReactTableSortingStateToSorting,
  convertSortingToReactTableSortingState,
} from '../../logic/sortingConversions';

export const useTableSorting = (
  sorting: Sorting,
  onSortingChange: (sorting: Sorting) => void,
) => {
  const initialSorting = useStatic(sorting);
  const sortingState = useMemo(
    () => convertSortingToReactTableSortingState(sorting),
    [sorting],
  );

  const onSortingStateChange = useCallback(
    (nextSortingFn: (prevSorting: SortingState) => SortingState) => {
      const nextSortingState = nextSortingFn(sortingState);
      if (nextSortingState.length === 0) {
        onSortingChange(initialSorting);
        return;
      }

      const nextSorting =
        convertReactTableSortingStateToSorting(nextSortingState);
      onSortingChange(nextSorting ?? initialSorting);
    },
    [sorting, onSortingChange, sortingState, initialSorting],
  );

  return {
    sortingState,
    onSortingStateChange,
  };
};
